var  _        = require('lodash')
    ,$        = global.jQuery
    ,ko       = require('knockout')
    ,core     = require('CoreModule')
    ,events   = core.Events
    ,helpers  = core.Helpers; 



function LoginAppViewModel(userMustRefresh) {

    console.error('LoginAppViewModel constructor', this, userMustRefresh);

    var self = this;

    self.userMustRefresh = ko.observable(userMustRefresh);

    self.busy            = ko.observable();
    self.alertCapsLock   = ko.observable();

    self.UserNameOrEmail = ko.observable(global.testUser);
    self.Password        = ko.observable(global.testPswd);
    
    self.Password.subscribe(function(){ core.Events.emitter.emit(core.Events.error, undefined) });

    self.authenticateUser = userMustRefresh ? _.noop : function () {
        console.log('starting user authentication');
        self.busy(true);
        core.SyncService.authenticateUser({ UserName: self.UserNameOrEmail, Password: self.Password })
            .done(function (data) {
                console.log('result of the sync service', data);
                var content = data && data.Content;
                if (content) return events.emitter.emit(events.authentication, content);// return events.emitter.emit(events.new_user_session, helpers.createInstanceWithValues(UserSession, content));
                core.Events.emitter.emit(core.Events.error, 'Invalid username or password.');
                self.busy(false);
            });
    }

    var init = (function () {

        events.emitter.on(events.resize, helpers.makeOnResizeDistribute([$('#filling1'), $('#middle0'), $('#filling2')]));

    })();

}

module.exports = {
    viewModel      : LoginAppViewModel
   ,template       : require('LoginView.html')
   ,title          : 'Login'
};